import { render, staticRenderFns } from "./SchemaExcelExportButton.vue?vue&type=template&id=10ff5ba1&"
import script from "./SchemaExcelExportButton.vue?vue&type=script&lang=js&"
export * from "./SchemaExcelExportButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports